import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import {
  inputVariants,
  type InputVariantsProps,
} from "@/shared/ui/atelier/Input.variants";
import { cn } from "@/shared/utils/style.util";

type NativeInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size">;

type InputProps = { leftIcon?: ReactNode } & NativeInputProps & InputVariantsProps;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({
    size, invalid, leftIcon, className, ...props
  }, ref) => {
    if (leftIcon !== undefined) {
      return (
        <div className="relative w-full">
          <span
            aria-hidden="true"
            className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-atelier-ink-muted"
          >
            {leftIcon}
          </span>
          <input
            ref={ref}
            aria-invalid={invalid === true ? true : undefined}
            className={cn(inputVariants({ size, invalid }), "pl-11", className)}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        ref={ref}
        aria-invalid={invalid === true ? true : undefined}
        className={cn(inputVariants({ size, invalid }), className)}
        {...props}
      />
    );
  },
);

Input.displayName = "Atelier.Input";

export { Input };
export type { InputProps };
